import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as Gear } from '../../assets/svgs/display-gear.svg'
import { ReactComponent as ColorPalette } from '../../assets/svgs/color-palatte.svg'
import BaseDropdown from '../dropdown/BaseDropdown_v2'
import { useTheme } from '../../contexts/themeContext'

export default function SettingsDropdown() {
  const { theme } = useTheme()
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()

  const actions = [
    {
      label: t('displaySettings.displaySettings'),
      icon: <ColorPalette width={18} height={18} />,
      handler: () => navigate('/display-settings'),
    },
  ]

  return (
    <BaseDropdown
      text={<Gear color={theme.defaultIconColor} width={25} height={25} />}
      iconOnly
      options={actions}
      label="label"
      variant="link"
      clickHandler={(action) => action.handler(action)}
      isLoading={false}
      arrow={false}
    />
  )
}
